/**
 * Carousel
 *
 * Converts a list of items into a carousel structure and
 * provides controls for the carousel.
 *
 * @class Carousel

 * @requires utilities.touch.swipe
 * @requires TweenLite
 * @requires TweenLiteCSS
  */

define('libs/carousel',['require','libs/utilities.touch.swipe','TweenLite','TweenLiteCSS'],function(require) {

    var _swipe = require('libs/utilities.touch.swipe'),
        _tween = require('TweenLite'),
        _tween_css = require('TweenLiteCSS');

    /**
     * The default settings.
     */
    var SETTINGS = {
        axis: 'x',
        eventsNext: ['carousel.next'],
        eventsPrev: ['carousel.prev'],
        wrapperClass: 'carousel-container',
        autoRotate: false,
        autoRotateTime: 5000,
        scrollBy: 1,
        runThroughFactor: 20,
        itemSelector: null,
        animationTime: 1000,
        easing: null, // a TweenLite easing function
        afterSwipe: null,
        start: 0,
        loop: false,
        touch: true,
        minItems: 2,
        handleResize: false,
        keyboardControl: false
    };

    /** @constructor */
    var Carousel = function() {
        this.init.apply(this, arguments);
    };

    /**
     * Initialize the component and set it options.

     * @param {Element} element The root element of the carousel.
     * @param {Object} options The custom settings.
     * @memberof Carousel
     */
    Carousel.prototype.init = function(element, options) {
        this.settings = $.extend({}, SETTINGS, options || {});

        // allow easy overwrites of methods.
        var proto = this.__proto__ || this.constructor.prototype;
        for (var key in proto) {
            if (proto.hasOwnProperty(key) && typeof this.settings[key] !== 'undefined') {
                this[key] = this.settings[key];
            }
        }

        this.element = element;
        this.$element = $(element);
        this.items = this.getItems(this.settings.itemSelector);

        // check if there are enough items in the carousel
        if (this.items.length < this.settings.minItems) {
            // not enough items, exit.
            return;
        }

        this.currentIndex = 0;
        this.offset = 0;
        this.cssProperty = this.settings.axis == 'x' ? 'left' : 'top';

        // setup the carousel.
        this.setup();

        // execute any custom control-builder function.
        this.addControls();

        // execute any custom behaviour on window resize.
        if (this.settings.handleResize) {
            $(window).on('resize', this.onResize.bind(this));
        }

        if (this.settings.keyboardControl) {
            this.startKeyboardListener();
        }

        // initialize autorotate
        if (this.settings.autoRotate) {
            // stop auto rotating the carousel on mouse over.
            this.$element.on('mouseenter', this.stopAutoRotate.bind(this));

            // start auto rotating again when the cursor leaves the carousel.
            this.$element.on('mouseleave', this.startAutoRotate.bind(this));

            this.startAutoRotate();
        }
    };

    /**
     * Start auto-rotating the carousel.
     * @memberof Carousel
     */
    Carousel.prototype.startAutoRotate = function() {
        // clear interval, can happen when carousel is loaded with the cursor already on it.
        clearInterval(this.autorotater);
        this.autorotater = setInterval(function() {
            this.next();
        }.bind(this), this.settings.autoRotateTime);
    };

    Carousel.prototype.startKeyboardListener = function() {
        this.keyboardListener = function(event) {
            // arrow left.
            if (event.keyCode == 37) {
                this.prev(event);
                // arrow right.
            } else if (event.keyCode == 39) {
                this.next(event);
            }
        }.bind(this);

        $(document).on('keydown', this.keyboardListener);
    };

    /**
     * Stop auto-rotating the carousel.
     * @memberof Carousel
     */
    Carousel.prototype.stopAutoRotate = function() {
        clearInterval(this.autorotater);
    };

    /**
     * Setup the structure for a classic type carousel.
     * @memberof Carousel
     */
    Carousel.prototype.setup = function() {
        this.container = this.$element.parent();
        this.container.addClass(this.settings.wrapperClass);

        // touch support.
        if (this.settings.touch) {
            // enable swiping through the carousel.
            new _swipe(this.container);
            this.container.on('swipe', this.onSwipe.bind(this));

            // enable moving the carousel by dragging across it.
            this.container.on('touchstart', this.onTouchstart.bind(this));
            this.touchmovehandler = this.onTouchmove.bind(this);
            this.container.on('touchmove', this.touchmovehandler);
            this.container.on('touchend', this.onTouchend.bind(this));
            this.container.on('touchcancel', this.onTouchend.bind(this));
        }


        // set the width or height of the element to the collective width/height of it's children.
        var property = this.settings.axis == 'x' ? 'width' : 'height';
        this.listSize = this.getContentSize();
        // apply the full size to the element.
        this.$element.css(property, this.listSize + 'px');
    };

    Carousel.prototype.getContentSize = function() {
        var contentSize = 0,
            property = this.settings.axis == 'x' ? 'width' : 'height';

        // get the collective width/height of the items.
        this.items.each(function() {
            var dimension = this.getBoundingClientRect()[property],
                $item = $(this);

            dimension += parseInt($item.css('margin-' + (property == 'width' ? 'left' : 'top'))) || 0;
            dimension += parseInt($item.css('margin-' + (property == 'width' ? 'right' : 'bottom'))) || 0;

            contentSize += dimension;
        });

        return contentSize;
    };

    /**
     * get all the items in the carousel.
     * @param {String} selector A css selector for the items.
     * @return {NodeList} the items.
     * @memberof Carousel
     */
    Carousel.prototype.getItems = function(selector) {
        if (selector) {
            // the the items in the root that match the selector.
            var items = $(selector, this.element);
        } else {
            // get the root element's child nodes.
            items = this.$element.children();
        }

        return items;
    };

    /**
     * Handle what happens when the window resizes.
     * @memberof Carousel
     */
    Carousel.prototype.onResize = function() {

    };

    /**
     * Add any controls for the carousel.
     */
    Carousel.prototype.addControls = function() {

    };

    /**
     * Handle a swipe event.
     * @param {Event} event The swipe event.
     * @param {Object} data The swipe details.
     * @memberof Carousel
     */
    Carousel.prototype.onSwipe = function(event, data) {
        this.lastSwipe = data;
    };

    /**
     * Handle a touchstart event.
     * @param {Event} event The touchstart event.
     * @memberof Carousel
     */
    Carousel.prototype.onTouchstart = function(event) {
        event = event.originalEvent;
        // do something, only when there's one touch point on the screen.
        if (!event.touches || event.touches.length > 1) return;

        // cancel any running animations.
        _tween.killTweensOf(this.element);

        this.dragstart = this.lasttouch = this.dragstart || {
            x: event.touches[0].pageX,
            y: event.touches[0].pageY
        };
    };

    /**
     * Handle a touchmove event.
     * Move the carousel when the user drags across it.
     * @param {Event} event The touchmove event.
     * @memberof Carousel
     */
    Carousel.prototype.onTouchmove = function(event) {
        event = event.originalEvent;
        // do something, only when there's one touch point on the screen. //TODO handle this.
        if (!event.touches || event.touches.length > 1) {
            return;
        }

        // get the direction of the movement. if it's on the same axis as the carousel, move the carousel.
        // if it's on the other axis, do nothing.
        if (!this.activeAxis && !this.ismoving) {
            this.activeAxis = Math.abs(event.changedTouches[0].pageX - this.dragstart.x) <
                Math.abs(event.changedTouches[0].pageY - this.dragstart.y) ? 'y' : 'x';
        }

        // calculate how much the touch has moved.
        var moved = this.lasttouch[this.activeAxis] -
            event.changedTouches[0][this.activeAxis == 'x' ? 'pageX' : 'pageY'];

        this.lasttouch = {
            x: event.changedTouches[0].pageX,
            y: event.changedTouches[0].pageY
        };

        // when just started moving.
        if (moved === 0 && !this.ismoving) {
            this.activeAxis = null;
            return;
        }

        // if it's on the other axis, stop listening and do nothing.
        if (this.activeAxis !== this.settings.axis) {
            this.container.off('touchmove', this.touchmovehandler);
            this.touchmovehandler = null;

            return;
        }

        // there's movement on the correct axis.
        this.ismoving = true;

        // if it's on the same axis, prevent scrolling the page.
        event.preventDefault();

        // move the carousel.
        this.setPosition(this.offset - moved);
    };

    /**
     * Handle a touchend event.
     * @memberof Carousel
     */
    Carousel.prototype.onTouchend = function() {
        // reset all the movement properties.
        this.dragstart = this.lasttouch = this.activeAxis = this.ismoving = null;

        // re-attach the touchmove handler if it has been removed.
        if (!this.touchmovehandler) {
            this.touchmovehandler = this.onTouchmove.bind(this);
            this.container.on('touchmove', this.touchmovehandler);
        }

        if (this.lastSwipe) {
            // execute the custom callback.
            if (typeof this.settings.afterSwipe == 'function') {
                this.settings.afterSwipe.call(this, this.lastSwipe);
            }

            // Keep scrolling for some distance, depending on the speed of the swipe.
            else {
                if (this.lastSwipe.direction == 'left' || this.lastSwipe.direction == 'up') {
                    var offset = this.offset - (this.lastSwipe.speed[this.settings.axis] / 2);
                }
                else if (this.lastSwipe.direction == 'right' || this.lastSwipe.direction == 'down') {
                    offset = this.offset + (this.lastSwipe.speed[this.settings.axis] / 2);
                }

                if (offset) {
                    // reposition the carousel if it has been pulled beyond the start or end slide.
                    if (offset > 0) offset = 0;
                    else {
                        var min = this.getMinOffset();
                        if (offset < min) offset = min; //TODO calculate after swipe time and distance nicely.
                    }

                    // find the item closest to this offset.
                    var olddistance = Infinity,
                        prop = this.cssProperty,
                        closest = 0,
                        listOffset = this.element.getBoundingClientRect()[prop];

                    for (var i = 0; i < this.items.length; i++) {
                        var itemOffset = this.items[i].getBoundingClientRect()[prop],
                            // get the distance from the target offset.
                            distance = Math.abs(Math.abs(offset) - Math.abs(listOffset - itemOffset));

                        if (distance < olddistance) {
                            olddistance = distance;
                            closest = i;
                        }
                    }

                    // animate the carousel to that item.
                    this.goto(closest);
                }
            }
        }
    };

    /**
     * Go to an item.
     * @param {Number} index The index of the item.
     * @memberof Carousel
     */
    Carousel.prototype.goto = function(index) {
        if (this.settings.loop) {
            if (index >= this.items.length) {
                index = 0;
            } else if (index < 0) {
                index = this.items.length - 1;
            }
        }
        if (this.items[index]) {
            var itemOffset = this.items[index].getBoundingClientRect()[this.cssProperty],
                listOffset = this.element.getBoundingClientRect()[this.cssProperty],
                offset = listOffset - itemOffset;

            this.animate(offset, this.settings.animationTime);
            this.$element.trigger('slidechange.carousel', {
                from: this.currentIndex,
                to: index
            });
            this.currentIndex = index;
        }
    };

    /**
     * Got to the next item.
     * @memberof Carousel
     */
    Carousel.prototype.next = function() {
        this.goto(this.currentIndex + 1);
    };

    /**
     * Got to the previous item.
     * @memberof Carousel
     */
    Carousel.prototype.prev = function() {
        this.goto(this.currentIndex - 1);
    };

    /**
     * Scroll the previous item into view.
     * @memberof Carousel
     */
    Carousel.prototype.scrollNext = function() {
        var item = this.getFirstItem(),
            prev = item !== 'undefined' ? item - this.settings.scrollBy : null;
        if (prev && this.isAnimating) {
            prev--;
        }
        if (prev < 0) prev = 0;

        this.goto(prev);
    };

    /**
     * Scroll the next item into view.
     * @memberof Carousel
     */
    Carousel.prototype.scrollPrev = function() {
        var item = this.getFirstItem(),
            next = item !== 'undefined' ? item + this.settings.scrollBy : null;
        if (next >= this.items.length) next = this.items.length - 1;

        this.goto(next);
    };

    /**
     * Get the first item inside the view.
     * @return {Number|undefined} the index of the item.
     * @memberof Carousel
     */
    Carousel.prototype.getFirstItem = function() {
        // get the first item that is inside the view.
        var viewRect = this.container[0].getBoundingClientRect(),
            prop = this.settings.axis == 'y' ? 'top' : 'left';
        for (var i = 0; i < this.items.length; i++) {
            var itemRect = this.items[i].getBoundingClientRect();
            if (itemRect[prop] >= viewRect[prop]) {
                break;
            }
        }

        return i;
    };

    /**
     * Scroll the carousel to it's new position.
     * @param {Number} targetvalue The new position for the carousel.
     * @param {Number} duration The duration of the animation in ms.
     * @memberof Carousel
     */
    Carousel.prototype.animate = function(targetvalue, duration) {
        if (targetvalue > 0) {
            targetvalue = 0;
        } else {
            var min = this.getMinOffset();
            if (targetvalue < min) targetvalue = min;
        }

        var tween_settings = {
            onComplete: this.onAnimationEnd.bind(this),
            // keep offset a live value.
            onUpdate: function() {
                this.offset = this.element._gsTransform[this.settings.axis == 'x' ? 'x' : 'y'];
            },
            onUpdateScope: this,
            ease: this.settings.ease,
            force3D:true
        };
        // set the property to animate.
        if (this.settings.axis == 'x') {
            tween_settings.x = targetvalue;
        } else {
            tween_settings.y = targetvalue;
        }

        this.isAnimating = true;

        new _tween.to(this.element, duration / 1000, tween_settings);
    };

    /**
     * Set the position of the carousel.
     * @param {Number} position The new position.
     * @memberof Carousel
     */
    Carousel.prototype.setPosition = function(position) {
        var tween_settings = {};
        // set the property to animate.
        if (this.settings.axis == 'x') {
            tween_settings.x = position;
        } else {
            tween_settings.y = position;
        }

        this.offset = position;
        _tween.set(this.element, tween_settings);
    };

    /**
     * Do this when the animation on the carousel has ended.
     * @memberof Carousel
     */
    Carousel.prototype.onAnimationEnd = function() {
        this.isAnimating = false;
    };

    /**
     * Get the minimal offset of the carousel.
     * @return {Number} The minimal offset in pixels.
     * @memberof Carousel
     */
    Carousel.prototype.getMinOffset = function() {
        return this.container[0].getBoundingClientRect()[this.settings.axis == 'x' ? 'width' : 'height'] -
            this.listSize;
    };

    return Carousel;
});

